<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="消息类型" prop="type" >-->
<!--        <a-radio-group name="radioGroup" :default-value="0" v-model="form.type">-->
<!--          <a-radio :value=0>系统消息</a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->

<!--      <a-form-model-item label="操作用户id,外键{zb_user.id}" prop="operateUserId" >-->
<!--        <a-input v-model="form.operateUserId" placeholder="请输入操作用户id,外键{zb_user.id}" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入标题"/>
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" >
        <a-textarea v-model="form.content" placeholder="请输入内容" :auto-size="{ minRows: 8, maxRows: 15 }"></a-textarea>
      </a-form-model-item>

<!--      <a-form-model-item label="用户id,外键{zb_user.id}" prop="userId" >-->
<!--        <a-input v-model="form.userId" placeholder="请输入用户id,外键{zb_user.id}" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMessage, addMessage, updateMessage } from '@/api/message/message'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,

        objId: null,

        operateUserId: null,

        title: null,

        content: null,

        read: null,

        userId: null,

        createTime: null,
        isDeleted: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // type: [
        //   { required: true, message: '系统消息不能为空', trigger: 'change' }
        // ],
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
      reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        objId: null,
        operateUserId: null,
        title: null,
        content: null,
        read: null,
        userId: null,
        createTime: null,
        isDeleted: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMessage({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },

    /**确认发布 */
    confirmRelease (row, ids) {
      this.form.isDeleted = false
      this.form.id = row.id
      updateMessage(this.form).then(response => {
        this.$message.success(
          '发布成功',
          3
        )
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },



    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {

          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMessage(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            this.form.type = 0
            this.form.isDeleted = true
            addMessage(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
